var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13.333,
    viewBox: "0 0 20 13.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M19.879,10.66A11.137,11.137,0,0,0,10,4.5,11.138,11.138,0,0,0,.121,10.66a1.123,1.123,0,0,0,0,1.014A11.137,11.137,0,0,0,10,17.833a11.138,11.138,0,0,0,9.879-6.16A1.123,1.123,0,0,0,19.879,10.66ZM10,16.167a5,5,0,1,1,5-5A5,5,0,0,1,10,16.167Zm0-8.333a3.309,3.309,0,0,0-.879.132A1.661,1.661,0,0,1,6.8,10.288,3.326,3.326,0,1,0,10,7.833Z",
    transform: "translate(0 -4.5)",
    fill: "rgba(28,36,57,0.22)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e631d3e547d8b4f45f60426b7eaef93f.svg";
export { ForwardRef as ReactComponent };